import { render, staticRenderFns } from "./CurrentUser.vue?vue&type=template&id=5ff0082e&scoped=true"
import script from "./CurrentUser.vue?vue&type=script&lang=ts"
export * from "./CurrentUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff0082e",
  null
  
)

export default component.exports